export default function transformCodeAndFeesTableData(
	data: string[][],
): string[][] {
	// Currency map for commonly used major currencies
	const currencyMap: { [code: string]: string } = {
		USD: "$",
		EUR: "€",
		JPY: "¥",
		GBP: "£",
		AUD: "A$",
		CAD: "CA$",
		CHF: "CHF",
		CNY: "¥",
		HKD: "HK$",
		NZD: "NZ$",
		SEK: "kr",
		NOK: "kr",
		KRW: "₩",
		SGD: "S$",
		INR: "₹",
		RUB: "₽",
		ZAR: "R",
		TRY: "₺",
		BRL: "R$",
		TWD: "NT$",
	};

	return data.map((row) => {
		// Extract the currency code (penultimate element) and amount (last element)
		const currencyCode = row[row.length - 2];
		const amount = row[row.length - 1];

		// Merge the currency symbol with the amount if applicable,
		// leave the amount as is if it is "-" or if the currency code isn't found.
		const merged =
			amount === "-"
				? "-"
				: currencyMap[currencyCode]
					? currencyMap[currencyCode] + amount
					: amount;

		// Return the row with the last two items replaced by the merged value.
		return [...row.slice(0, row.length - 2), merged];
	});
}
